import { render, staticRenderFns } from "./UserGroupCatalogPermissions.vue?vue&type=template&id=0badc4ce&scoped=true"
import script from "./UserGroupCatalogPermissions.vue?vue&type=script&lang=js"
export * from "./UserGroupCatalogPermissions.vue?vue&type=script&lang=js"
import style0 from "./UserGroupCatalogPermissions.vue?vue&type=style&index=0&id=0badc4ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badc4ce",
  null
  
)

export default component.exports